const isSet = value => value !== undefined && value !== null;

export const getLinkTypeFlags = link => {
    const isSurvey = isSet(link.surveyId);
    const isMicrosite = isSet(link.linkedMicrositeId);
    const isMenu = isSet(link.menuId);
    const isForm = isSet(link.formId);
    const isFile = isSet(link.fileUrl);
    return {
        isSurvey,
        isMicrosite,
        isMenu,
        isForm,
        isFile,
        isLink: !isSurvey && !isMicrosite && !isMenu && !isForm && !isFile,
    };
};

const getIncompatibilityError = ({ isSurvey, isMicrosite, isMenu }, isBrand) => {
    if (isSurvey && isBrand) return 'MicrositesPage.surveyNotAvailableForBrand';
    if (isMenu && isBrand) return 'MicrositesPage.menuNotAvailableForBrand';
    if (isMicrosite && !isBrand) return 'MicrositesPage.micrositeNotAvailableForLocation';
    return null;
};

export const isLinkIncompatible = (link, isBrand) => !!getIncompatibilityError(getLinkTypeFlags(link), isBrand);

export const getLinkReferenceError = (
    link,
    {
        isBrand,
        surveysOptions,
        micrositeOptions,
        isMicrositesLoaded,
        menusOptions,
        isMenusLoaded,
        formsOptions,
        isFormsLoaded,
    },
) => {
    const flags = getLinkTypeFlags(link);
    const { isSurvey, isMicrosite, isMenu, isForm } = flags;
    const incompatibilityError = getIncompatibilityError(flags, isBrand);
    if (incompatibilityError) return incompatibilityError;
    if (isSurvey && !surveysOptions.some(o => o.value === link.surveyId))
        return 'MicrositesPage.surveyNotAvailableForLocation';
    if (isMicrosite && isMicrositesLoaded && !micrositeOptions.some(o => o.value === link.linkedMicrositeId))
        return 'MicrositesPage.micrositeNotAvailableForBrand';
    if (isMenu && isMenusLoaded && !menusOptions.some(o => o.value === link.menuId))
        return 'MicrositesPage.menuNotAvailable';
    if (isForm && isFormsLoaded && !formsOptions.some(o => o.value === link.formId))
        return 'MicrositesPage.formNotAvailable';
    return null;
};

export const isLinkValid = (link, context) =>
    !!link.title &&
    !getLinkReferenceError(link, context) &&
    (!!link.link || !!link.surveyId || !!link.fileUrl || !!link.linkedMicrositeId || !!link.menuId || !!link.formId);
